import {
  Box,
  Flex,
  Heading,
  Image,
  LinkBox,
  LinkOverlay,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  faRankingStar,
} from "@fortawesome/pro-regular-svg-icons";
import React from "react";
import { Link, useParams } from "react-router-dom";

export const TaxonIndexItem = ({ taxon, num, icon = faRankingStar }) => {
  const { locale } = useParams();
  const hoverBg = useColorModeValue("blackAlpha.200", "whiteAlpha.200")
  const bg = useColorModeValue("blackAlpha.100", "whiteAlpha.100")

  return <LinkBox
    backgroundImage={`url("data:image/svg+xml,%3Csvg width='84' height='48' viewBox='0 0 84 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h12v6H0V0zm28 8h12v6H28V8zm14-8h12v6H42V0zm14 0h12v6H56V0zm0 8h12v6H56V8zM42 8h12v6H42V8zm0 16h12v6H42v-6zm14-8h12v6H56v-6zm14 0h12v6H70v-6zm0-16h12v6H70V0zM28 32h12v6H28v-6zM14 16h12v6H14v-6zM0 24h12v6H0v-6zm0 8h12v6H0v-6zm14 0h12v6H14v-6zm14 8h12v6H28v-6zm-14 0h12v6H14v-6zm28 0h12v6H42v-6zm14-8h12v6H56v-6zm0-8h12v6H56v-6zm14 8h12v6H70v-6zm0 8h12v6H70v-6zM14 24h12v6H14v-6zm14-8h12v6H28v-6zM14 8h12v6H14V8zM0 8h12v6H0V8z' fill='%239C92AC' fill-opacity='0.4' fill-rule='evenodd'/%3E%3C/svg%3E")`}
    bg={bg}
    _hover={{ bg: hoverBg }}
    as={Flex}
    px="2"
    py="16"
    alignItems="center"
    justifyContent="center"
    gap="4"
    direction="column"
    position="relative"
    key={taxon.id}
  >
    <Flex direction="row" gap="2">
      {taxon.products.map(img => <Link to={`/${locale}/products/${img.slug}`} key={img.slug}>
        <Image flex="1" rounded="md" htmlWidth="96" htmlHeight="96" src={img.src} />
      </Link>
      )}
    </Flex>
    <Flex alignItems="center" direction="column" gap="2">
      <Heading as="h3" size="md">
        <LinkOverlay as={Link} to={taxon.href + "?order=popularity"}>
          {taxon.title}
        </LinkOverlay>
      </Heading>
      <Box fontWeight="semibold" color="gray.500">{taxon.taxonomy.title}</Box>
    </Flex>
  </LinkBox>
}
